import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Spacer, Text } from '@vinted/web-ui';
import ContentLoader from 'components/ContentLoader';
import RandomUserSignup from 'components/RandomUserSignup';
import SeparatedList from 'components/SeparatedList';
import { getUserById } from 'data/api';
import * as selectors from 'state/auth/selectors';
import useGoogleTagManagerTrack from 'hooks/useGoogleTagManagerTrack';
import { FormName, GoogleTagManagerEvent, PageType } from 'constants/google';
import Facebook from '../Facebook';
import Google from '../Google';
import Apple from '../Apple';
import BusinessRegistrationLink from './BusinessRegistrationsLink';
import SelectTypeFooter from './SelectTypeFooter';
import SelectTypeHeader from './SelectTypeHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

const SelectType = () => {
  const referrerId = useSelector(selectors.getReferrerId);
  const isRandomUserSignupEnabled = useSelector(selectors.getIsRandomUserSignupEnabled);
  const isRegisterView = !useSelector(selectors.getIsSelectTypeLogin);
  const {
    googleAnalyticsTrack
  } = useGoogleTagManagerTrack();
  const {
    0: error,
    1: setError
  } = useState();
  const {
    0: hasReferralError,
    1: setHasReferralError
  } = useState(false);
  const {
    0: referrer,
    1: setReferrer
  } = useState(null);
  const loadReferrer = isRegisterView && referrerId && (referrer === null || referrer === void 0 ? void 0 : referrer.id) !== referrerId;
  useEffect(() => {
    function pushGoogleAnalyticsEvent() {
      if (isRegisterView) {
        googleAnalyticsTrack({
          event: GoogleTagManagerEvent.modalView,
          customTagObject: {
            formName: FormName.Register,
            pageType: PageType.Registration
          }
        });
      } else {
        googleAnalyticsTrack({
          event: GoogleTagManagerEvent.modalView,
          customTagObject: {
            formName: FormName.Login,
            pageType: PageType.Login
          }
        });
      }
    }

    pushGoogleAnalyticsEvent();
  }, [isRegisterView, googleAnalyticsTrack]);
  useEffect(() => {
    if (!loadReferrer) return;

    async function fetchUser() {
      if (!referrerId) return;
      const response = await getUserById({
        id: referrerId
      });

      if ('errors' in response) {
        setHasReferralError(true);
        return;
      }

      setReferrer(response.user);
    }

    fetchUser();
  }, [loadReferrer, referrerId]);

  if (!hasReferralError && loadReferrer) {
    return /*#__PURE__*/_jsx(ContentLoader, {
      styling: ContentLoader.Styling.Wide,
      size: ContentLoader.Size.Large,
      testId: "select-type-loader"
    });
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "u-ui-padding-horizontal-large u-ui-padding-bottom-x-large",
      children: [/*#__PURE__*/_jsx(SelectTypeHeader, {
        referrer: referrer
      }), /*#__PURE__*/_jsx(Spacer, {}), error && /*#__PURE__*/_jsx(Text, {
        text: error,
        theme: "warning",
        width: Text.Width.Parent,
        alignment: Text.Alignment.Center
      }), /*#__PURE__*/_jsx(Spacer, {
        size: Spacer.Size.Large
      }), /*#__PURE__*/_jsxs(SeparatedList, {
        separator: /*#__PURE__*/_jsx(Spacer, {}),
        children: [/*#__PURE__*/_jsx(Facebook, {
          setError: setError
        }), /*#__PURE__*/_jsx(Google, {
          setError: setError
        }), /*#__PURE__*/_jsx(Apple, {
          setError: setError
        }), isRandomUserSignupEnabled && isRegisterView && /*#__PURE__*/_jsx(RandomUserSignup, {})]
      }), /*#__PURE__*/_jsx(Spacer, {
        size: Spacer.Size.XLarge
      }), /*#__PURE__*/_jsx(SelectTypeFooter, {})]
    }), isRegisterView && /*#__PURE__*/_jsx(BusinessRegistrationLink, {})]
  });
};

export default SelectType;